import { Button } from '@app/components/core/button/Button'
import { Text } from '@app/components/core/typography/Text'
import { Modal } from '@app/components/blocks/modal/Modal'
import { useState } from 'react'
import { useTranslations } from '@i18n/useLanguage'
import { useClient } from '@based/sdk/react'
import { useLocation } from 'wouter'
import { pages } from '@app/util/links'
import { useToast } from '@app/util/hooks/useToast'
import { faTrash } from '@fortawesome/pro-regular-svg-icons'

export const DeleteProfileButton = () => {
  const [isOpen, setIsOpen] = useState(false)
  const [isDeleting, setIsDeleting] = useState(false)
  const t = useTranslations()
  const translations = t.app.dashboard.profile
  const client = useClient()
  const [, navigate] = useLocation()
  const { showFailToast } = useToast()

  const handleDeleteProfile = async () => {
    setIsDeleting(true)
    try {
      await client.call('delete-profile')
      setIsOpen(false)
      navigate(pages.home)
    } catch {
      showFailToast()
    } finally {
      setIsDeleting(false)
    }
  }

  return (
    <>
      <Button
        variant="primary"
        size="small"
        label={translations.deleteProfileTitle}
        icon={faTrash}
        iconPosition="left"
        onClick={() => setIsOpen(true)}
        style={{ width: 'fit-content', alignSelf: 'flex-end' }}
      />
      <Modal
        isOpen={isOpen}
        backLabel={translations.cancel}
        confirmLabel={translations.confirm}
        loading={isDeleting}
        onClose={() => setIsOpen(false)}
        onConfirm={() => void handleDeleteProfile()}
      >
        <Text.Medium>{translations.deleteProfileConfirmation}</Text.Medium>
      </Modal>
    </>
  )
}
